module.exports = __webpack_public_path__ + "static/media/profit.6fa3c70b.png";